module.exports = __webpack_public_path__ + "img/25_71.365d7295.png";